import CrudRepository from './CrudRepository'
export default class PressReleaseSliderRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/news/web')
  }
}
